(function () {
  'use strict';

  angular.module('app').component('versioningDetail', versioningDetail());

  function versioningDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onAppVersionSaved: '&',
        onAppVersionCanceled: '&',
        currentAppVersion: '<',
        additionalLanguages: '<',
      },
      controller: VersioningDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/versioning/versioning-detail/versioning-detail.component.html',
    };
  }

  VersioningDetailComponent.$inject = ['UtilService', 'VersioningService'];

  function VersioningDetailComponent(UtilService, VersioningService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.editAppVersion = editAppVersion;
    vm.cancelEdit = cancelEdit;
    vm.openTranslations = openTranslations;
    vm.saveAppVersion = saveAppVersion;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          is_current: true,
        };

        setTranslations(vm.item);
      }
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editAppVersion();
      }

      setTranslations(item);
    }

    function editAppVersion() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      setItemOptions(vm.item);
    }

    function openTranslations() {
      VersioningService.openMeasurementUnitTranslations(vm.item, vm.additionalLanguages);
    }

    function setTranslations(item) {
      var translations = [];
      var i;

      if (!item.id) {
        // create
        for (i = 0; i < vm.additionalLanguages.length; i++) {
          translations.push({
            name: vm.additionalLanguages[i].name,
            lang: vm.additionalLanguages[i].lang,
            description: '',
          });
        }
      } else {
        // edit
        var translation;
        for (i = 0; i < vm.additionalLanguages.length; i++) {
          translation = {
            name: vm.additionalLanguages[i].name,
            lang: vm.additionalLanguages[i].lang,
          };

          for (var j = 0; j < item.translations.length; j++) {
            if (vm.additionalLanguages[i]['lang'] === item.translations[j]['lang']) {
              translation.description = item.translations[j]['content'];
              break;
            }
          }

          translations.push(translation);
        }
      }

      item.translations = translations;
    }

    // Create/Update
    function saveAppVersion(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      var translations = [];
      vm.item.translations.forEach(function (translation) {
        translations.push(translation.description);
      });

      // var item = {
      //   id: vm.item.id,
      //   version_number: vm.item.version_number,
      //   translations: translations,
      // };

      // return false;

      vm.sendingForm = true;
      VersioningService.saveAppVersion(vm.item).then((response) => {
        if (!response.errors) {
          // Success
          setItemOptions(response);
          vm.onAppVersionSaved({ item: response });
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onAppVersionCanceled();
    }
  }
})();
